<template>
    <b-container class="mt-4" fluid>
        <base-table
            :fixed-fields="fixedFields"
            class="mx-3"
            vuex-state="patients"
            vuex-action="getPatients"
            table-header-translation-key="patient.listHeader"
            @row-clicked="patientSelected"
        >
            <template v-slot:pre-filter>
                <hemocir-button
                    :title="$t('patient.addPatient')"
                    :to="{name: 'patient-add'}"
                    font-awesome-icon="fa-user-plus"
                    variant="secondary"
                    class="mb-3"
                />
            </template>
        </base-table>

        <base-legend
            class="float-left mx-3 mt-3"
            :complete-legend-helper="$t('patient.completelabel')"
            :incomplete-legend-helper="$t('patient.incompletelabel')"
        />
    </b-container>
</template>

<script>
    import BaseTable from "@/components/BaseTable";
    import {displayChoice, format_number_surgeries, generate_table_field} from "@/utils/formatting";
    import {mapActions, mapState} from "vuex";
    import BaseLegend from "@/components/BaseLegend";

    export default {
        name: "PatientListPage",
        components: {
            BaseLegend,
            BaseTable
        },
        computed: {
            ...mapState(['patientFields']),
            fixedFields() {
                return [
                    {key: 'code', translation_key: 'patient.code'},
                    {key: 'birthday', translation_key: 'patient.birthday'},
                    {
                        key: 'hemophilia_type',
                        translation_key: 'patient.hemophilia_type',
                        formatter: (value) => this.displayChoice('hemophilia_type', value, 'patientFields')
                    },
                    {
                        key: 'number_surgeries',
                        translation_key: 'patient.numberSurgeries',
                        formatter: format_number_surgeries()
                    },
                    {
                        key: 'number_tooth_extractions',
                        translation_key: 'patient.numberDentalExtractions',
                        formatter: format_number_surgeries
                    },
                    {
                        key: 'number_minor_surgeries',
                        translation_key: 'patient.numberMinorSurgeries',
                        formatter: format_number_surgeries
                    },
                    {
                        key: 'number_major_surgeries',
                        translation_key: 'patient.numberMajorSurgeries',
                        formatter: format_number_surgeries
                    },
                    {key: 'state', translation_key: 'patient.state'},
                ].map(value => generate_table_field(value, this.translation_function));
            },
        },
        methods: {
            ...mapActions(['selectPatient']),
            patientSelected(item) {
                this.$router.push({ name: 'patient-detail-surgeries', params: { patientId: item.id } });
            },
            translation_function(value) {
                return this.$t(value);
            },
            displayChoice(field, value, fields) {
                return displayChoice(value, this[fields][field]) || '-';
            },
        },
    };
</script>

